import React, { useCallback, useEffect, useState } from 'react';
import PageHeader from '@/components/PageHeader';
import AdminBillingNav from '@/components/adminBilling/AdminBillingNav';
import StatusChip from '@/components/adminBilling/StatusChip';
import { adminBillingService, formatCents } from '@/api/services/adminBilling';
import { formatApiError } from '@/utils/formatApiError';
import { DataTableScrollArea } from '@/components/table';

export default function AdminBillingPaymentsPage() {
  const [items, setItems] = useState<Record<string, unknown>[]>([]);
  const [cursor, setCursor] = useState<string | null>(null);
  const [hasMore, setHasMore] = useState(false);
  const [status, setStatus] = useState('');
  const [error, setError] = useState<string | null>(null);

  const load = useCallback((nextCursor?: string | null) => {
    adminBillingService
      .payments({ status: status || undefined, cursor: nextCursor || undefined })
      .then((res) => {
        setItems((prev) => (nextCursor ? [...prev, ...res.items] : res.items));
        setCursor(res.nextCursor ?? null);
        setHasMore(res.hasMore);
      })
      .catch((e) => setError(formatApiError(e)));
  }, [status]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="admin-billing-page">
      <AdminBillingNav />
      <PageHeader title="Payments" subtitle="All platform payment records." />
      {error ? <div className="alert alert-error">{error}</div> : null}
      <section className="panel">
        <div className="table-action-bar">
          <select value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="">All statuses</option>
            <option value="succeeded">Succeeded</option>
            <option value="failed">Failed</option>
            <option value="refunded">Refunded</option>
            <option value="pending">Pending</option>
          </select>
        </div>
        <DataTableScrollArea>
        <table className="data-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Organization</th>
              <th>Amount</th>
              <th>Provider</th>
              <th>Status</th>
              <th>Method</th>
            </tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={String(p.id)}>
                <td>{p.createdAt ? new Date(String(p.createdAt)).toLocaleString() : '—'}</td>
                <td>{String(p.organizationName || p.organizationSlug)}</td>
                <td>{formatCents(Number(p.amountCents), String(p.currency || 'EUR'))}</td>
                <td>{String(p.provider)}</td>
                <td><StatusChip status={String(p.status)} /></td>
                <td>{String(p.method || '—')}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </DataTableScrollArea>
        {hasMore && cursor ? (
          <button type="button" className="btn btn-secondary" onClick={() => load(cursor)}>
            Load more
          </button>
        ) : null}
      </section>
    </div>
  );
}
